import React from 'react';
import { usePagination } from 'react-instantsearch';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface PaginationProps {
  className?: string;
}

export const Pagination: React.FC<PaginationProps> = ({ className = '' }) => {
  const {
    pages,
    currentRefinement,
    nbPages,
    canRefine,
    refine,
    isFirstPage,
    isLastPage,
  } = usePagination();

  if (!canRefine || nbPages <= 1) {
    return null;
  }

  const handlePrevious = () => {
    if (!isFirstPage) {
      refine(currentRefinement - 1);
    }
  };

  const handleNext = () => {
    if (!isLastPage) {
      refine(currentRefinement + 1);
    }
  };

  const handlePageClick = (page: number) => {
    refine(page);
  };

  return (
    <div className={`flex items-center justify-center gap-2 ${className}`}>
      <Button
        variant="outline"
        size="sm"
        disabled={isFirstPage}
        onClick={handlePrevious}
        className="flex items-center gap-1"
      >
        <ChevronLeft className="h-4 w-4" />
        Previous
      </Button>
      
      <div className="flex items-center gap-1">
        {pages.map((page) => (
          <Button
            key={page}
            variant={currentRefinement === page ? "default" : "outline-solid"}
            size="sm"
            onClick={() => handlePageClick(page)}
            className="min-w-[40px]"
          >
            {page + 1}
          </Button>
        ))}
      </div>
      
      <Button
        variant="outline"
        size="sm"
        disabled={isLastPage}
        onClick={handleNext}
        className="flex items-center gap-1"
      >
        Next
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
};